/** The bare `/onboarding` entry. The parent route's wizard resolves the resume step and replaces this URL. */
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_shell/onboarding/')({})
